export default "__VITE_ASSET__KvAHJ8kc__"